<nav class="navbar is-fixed-bottom is-transparent">
  <div #tickerContainer class="ticker-container">
    <span class="live-gacha-item" *ngFor="let item of liveGachaFeed">
      {{ item }}
    </span>
  </div>
</nav>